<template>
  <Toast/>
  <div class="row">
    <div class="col-12">
      <h2 class="titre">
        Modifier catégorie
      </h2>
      <EnteteTableValeurDossier ref="enteteTableValeurDossier" :isModifier="true"
                                :isGenre="true" :isNature="true" :isType="true" :valeur="categorie"
                                :entite="entite" :genre="genre" :nature="nature" :type="type"/>
      <RoleSecuriteTV ref="roleSecuriteTV" :isModifier="true" :roles="this.categorie.roles"/>
      <FrancaisComposant ref="francaisComposant" :libelle="this.categorie.libelle" :isModifier="true"/>
      <Justification ref="justification"/>
      <div class="row pt-2">
        <div class="col">
          <div v-if="enregistrementEnCours == false">
            <Button type="button" label="Enregistrer" @click="enregistrer"/>
          </div>
          <div v-else>
            <vue-loaders name="ball-beat" class="justify-center"></vue-loaders>
          </div>
        </div>
        <div class="col">
          <Button type="button" label="Audit" @click="auditCategorie"/>
        </div>
        <div class="col">
          <Button type="button" label="Annuler" @click="fermer"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import EnteteTableValeurDossier from "@/components/pilotage/ClassementDeDossier/Ajouter/EnteteTableValeurDossier.vue";
import FrancaisComposant from "@/components/pilotage/ClassementDeDossier/Ajouter/FrancaisComposant.vue";
import RoleSecuriteTV from "@/components/pilotage/ClassementDeDossier/Ajouter/RoleSecuriteTV.vue";
import Justification from "@/components/pilotage/ClassementDeDossier/InformationJustification.vue";
import axios from "axios";
import {mapGetters} from "vuex";

export default {
  name: "ModifierCategorie",
  components: {Justification, FrancaisComposant, EnteteTableValeurDossier, RoleSecuriteTV},
  computed: {
    ...mapGetters({
        jeton: 'cardex/jeton',
        profil: 'cardex/profil',
        categorie: 'pilotage/categorie'
    })
  },
  mounted() {
    axios.defaults.headers.common['cleProfil'] = this.profil.cle;
    this.$root.$refs.breadcrumbComp.ajout("Modifier Catégorie");
    this.entite = Number(this.$route.params.entite);
    this.genre = Number(this.$route.params.genre);
    this.nature = Number(this.$route.params.nature);
    this.type = Number(this.$route.params.type);
    this.getCategorie();
  },
  data() {
    return {
      enregistrementEnCours: false,
      decisionTableValeur: {},
      code: "CATEGORIE",
      entite: null,
      genre: null,
      nature: null,
      type: null,
    };
  },
  methods: {
    getCategorie() {
      this.$store.dispatch("pilotage/consulterTableValeurAction", {
        cle: this.$route.params.cle
      }).then((res) => {
        this.$store.commit('pilotage/CATEGORIE',res.data);
        this.$refs.enteteTableValeurDossier.assignerValeur(res.data);
        this.$refs.francaisComposant.setValeurFrancaisLocal(res.data.libelleVO);
      });
    },
    enregistrer() {
      this.enregistrementEnCours = true;
      this.decisionTableValeur.tableValeurVO = this.$refs.enteteTableValeurDossier.getTableValeurLocal();
      this.decisionTableValeur.libelleVO = this.$refs.francaisComposant.getValeurFrancaisLocal();
      this.decisionTableValeur.rolesVO = this.$refs.roleSecuriteTV.getRoleSecuriteTVLocalLocal();
      this.decisionTableValeur.justificationVO = this.$refs.justification.getJustification();
      this.$store.dispatch('pilotage/modifierTableValeurAction', {tableValeur: this.decisionTableValeur}).then((res) => {
        this.enregistrementEnCours = false;
        this.$root.$refs.messagesComp.messagesList = res.data.messages;
        if (res?.data?.messages == 0 || res?.data == "") {
          this.$toast.add(
              {severity:'success',
                summary: 'Sauvegarder',
                detail:'La sauvegarde est réussi.',
                life: 6000});
        }
      }).catch(err => {
        this.$toast.add({
            severity: 'error',
            summary: 'Sauvegarder',
            detail: `Erreur lors de l'enregistrement du catégorie: ${err}`,
            life: 6000
        })
      })
    },
    auditCategorie() {
      this.decisionTableValeur.tableValeurVO = this.$refs.enteteTableValeurDossier.getTableValeurLocal();
      this.$router.push({
        name: 'tableValeurAuditModifications',
        params: {cle: this.decisionTableValeur.tableValeurVO.cle}
      });
    },
    fermer() {
      this.$root.$refs.breadcrumbComp.rediriger();
    },
  }
}
</script>